import { Injectable } from '@angular/core';



@Injectable()
export class LogicService {



  constructor() {
  }



  // From https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
  // Will probably refactor array at some point to be a Material Design table instead
  compareValues(key, order = 'asc') {
    return function(a, b) {

      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = (typeof a[key] === 'string') ?
        a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string') ?
        b[key].toUpperCase() : b[key];

      let comparison = 0;

      // console.log(`Going to compare varA: ${varA}`)
      // console.log(`Going to compare varB: ${varB}`)
      // if (Number(varA) > Number(varB)) {
      //   comparison = 1;
      // } else if (Number(varA) < Number(varB)) {
      //   comparison = -1;
      // }
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }

      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );

    };
  }



  // Sorts an object based on it's property called number
  sortObject(obj) {
    // Initialize empty variables
    var arr = [];
    var returnObject = {};
    
    // Iterate over the object and turn it into an array
    Object.keys(obj).forEach( elementInObject => {
      arr.push(obj[elementInObject])
    })

    // Sort the array based on number
    arr.sort(this.compareValues('number'));

    // Turn the array back into an object
    arr.forEach( elementInArray => {
      const keyToAdd = `${elementInArray['number']}${elementInArray['key']}`
      returnObject[keyToAdd] = elementInArray;
    })

    // Return the sorted object
    return returnObject;
  }



  // Shuffle(randomize) the order of an array
  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    // No 'return' necessary since arrays work off pointers anyways
  }



}
